import i18n from '@/plugins/i18n';

export const functionTableHeader = () => [
  {
    key: 'timestamp',
    name: i18n.global.t('aws.timeStamp'),
  },
  {
    key: 'requestId',
    name: i18n.global.t('aws.requestId'),
    tooltip: i18n.global.t('aws.requestIdTooltip'),
  },
  {
    key: 'eventSource',
    name: i18n.global.t('aws.eventSource'),
    tooltip: i18n.global.t('aws.eventSourceTooltip'),
  },
  {
    key: 'isError',
    name: i18n.global.t('aws.error'),
    tooltip: i18n.global.t('aws.errorTooltip'),
  },
  {
    key: 'initDuration',
    name: i18n.global.t('aws.initDuration'),
    tooltip: i18n.global.t('aws.initDurationTooltip'),
  },
  {
    key: 'duration',
    name: i18n.global.t('aws.duration'),
    tooltip: i18n.global.t('aws.durationTooltip'),
  },
  {
    key: 'memoryUsage',
    name: i18n.global.t('aws.memoryUsageMB'),
    tooltip: i18n.global.t('aws.memoryUsageTooltip'),
  },
];

export const constants = {
  tableView: 'tableView',
};

export const costAggregationFactor = 10000000000;

export const valueTypeCheck = 'avgofavg';
